import queryString from 'query-string'
import { makeRequest } from '../base/axios.ts'

export default {
  loadShareable: (shareableId, shareableType) => {
    const url = queryString.stringifyUrl({
      url: `/api/v1/shareables`,
      query: {
        shareable_id: shareableId,
        shareable_type: shareableType,
      },
    })
    return makeRequest({
      url,
      requestId: `load-shareable-${shareableType}-${shareableId}`,
    })
  },
}
